var r = /* @__PURE__ */ ((e) => (e.AlignSelf = "iress--align-self", e.Base = "iress-u-col", e.Offset = "iress--offset", e.Span = "iress--span", e))(r || {}), t = /* @__PURE__ */ ((e) => (e.Start = "start", e.End = "end", e.Center = "center", e.Stretch = "stretch", e))(t || {});
const v = ["start", "end", "center", "stretch"];
var n = /* @__PURE__ */ ((e) => (e.Auto = "auto", e.One = "1", e.Two = "2", e.Three = "3", e.Four = "4", e.Five = "5", e.Six = "6", e.Seven = "7", e.Eight = "8", e.Nine = "9", e.Ten = "10", e.Eleven = "11", e.Twelve = "12", e))(n || {});
const u = [
  "auto",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12
];
var i = /* @__PURE__ */ ((e) => (e.None = "0", e.One = "1", e.Two = "2", e.Three = "3", e.Four = "4", e.Five = "5", e.Six = "6", e.Seven = "7", e.Eight = "8", e.Nine = "9", e.Ten = "10", e.Eleven = "11", e))(i || {});
const c = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11
];
export {
  v as COL_ALIGN_SELFS,
  c as COL_OFFSETS,
  u as COL_SPANS,
  t as ColAlignSelf,
  r as ColCssClass,
  i as ColOffset,
  n as ColSpan
};
